import { Component } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

import { AccountApiService } from "@bitwarden/common/abstractions/account/account-api.service";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { StateService } from "@bitwarden/common/abstractions/state.service";
import { Verification } from "@bitwarden/common/types/verification";
import { BlobbyService } from "@bitwarden/web-vault/app/services/blobby/blobby.service";
import { VaultSyncCacheService } from "@bitwarden/web-vault/app/services/syncing/vault-sync-cache.service";

@Component({
  selector: "app-delete-account",
  templateUrl: "delete-account.component.html",
})
export class DeleteAccountComponent {
  formPromise: Promise<void>;

  deleteForm = this.formBuilder.group({
    verification: undefined as Verification | undefined,
  });

  constructor(
    private i18nService: I18nService,
    private platformUtilsService: PlatformUtilsService,
    private formBuilder: FormBuilder,
    private accountApiService: AccountApiService,
    private logService: LogService,
    private dialogRef: MatDialogRef<DeleteAccountComponent>,
    private blobbyService: BlobbyService,
    private stateService: StateService,
    private vaultSyncCacheService: VaultSyncCacheService,
  ) {}

  async submit() {
    try {
      const userId = await this.stateService.getUserId();
      const verification = this.deleteForm.get("verification").value;
      this.formPromise = this.accountApiService.deleteAccount(verification);
      await this.formPromise;
      if (userId) {
        this.vaultSyncCacheService.clearCache(userId);
      }
      this.platformUtilsService.showToast(
        "success",
        this.i18nService.t("accountDeleted"),
        this.i18nService.t("accountDeletedDesc"),
      );
      this.dialogRef.close();
      this.blobbyService.setInitialised(false);
    } catch (e) {
      this.logService.error(e);
    }
  }
}
